import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { IngestionPartFilters } from "./components/IngestionPartFilters";
import {
  IngestionPartSearchRequestProvider,
  IngestionPartTable,
} from "./components/IngestionPartTable";

export function IngestionPartsPage() {
  return (
    <TablePage
      title="Search Ingestion Parts"
      RequestProvider={IngestionPartSearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <IngestionPartTable />
        </>
      }
      filters={<IngestionPartFilters />}
    />
  );
}
